import { render } from "./QuestionView.vue?vue&type=template&id=7498b4ce&ts=true"
import script from "./QuestionView.vue?vue&type=script&lang=ts"
export * from "./QuestionView.vue?vue&type=script&lang=ts"

import "./QuestionView.vue?vue&type=style&index=0&id=7498b4ce&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__